import React from 'react';
import { CheckIcon, LaptopIcon, MonitorIcon, PrinterIcon, SmartphoneIcon, TabletIcon } from 'lucide-react';
import { devices, DeviceIcon, digitalNo } from '../data/copy';
const deviceIcons: Record<DeviceIcon, typeof LaptopIcon> = {
  phone: SmartphoneIcon,
  tablet: TabletIcon,
  laptop: LaptopIcon,
  computer: MonitorIcon
};
export function DigitalSection() {
  return <section className="defer-paint w-full bg-navy py-10 sm:py-14" aria-labelledby="digital-heading" data-id="element-51" data-mp="1d37xookzdyz9">
      <div className="mx-auto grid max-w-5xl gap-10 px-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-16" data-id="element-52" data-mp="25q2hdj9z4ubo">
        

        
      </div>
    </section>;
}